import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

const DeleteConfirmationModal = ({ isOpen, toggle, onConfirmDelete }) => (
    <Modal
        isOpen={isOpen}
        toggle={toggle}
        className="modal-dialog-v-centered modal-horizontally-centered"
    >
        <ModalHeader>Confirm Delete</ModalHeader>
        <ModalBody>
            <p>
                Are you sure you want to delete the selected media attachments?
            </p>
        </ModalBody>
        <ModalFooter>
            <button className="btn btn-cancel col" onClick={toggle}>
                Cancel
            </button>
            <button className="btn btn-primary col" onClick={onConfirmDelete}>
                Delete
            </button>
        </ModalFooter>
    </Modal>
)

export default DeleteConfirmationModal
